import propTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getProperty, removeProperty } from '../../../reducers/propertiesSlice';

import formatPrice from '../../../utils/formatPrice';

const OnGoogleApiLoadedMarker = ({ id, zoom, price, state, approximate_location }) => {
  // ------------------------------- CONSTRUCTOR -------------------------------
  const dispatch = useDispatch();
  const { property } = useSelector((state) => state.properties);

  // ---------------------------- DISPLAY FUNCTIONS ----------------------------
  const isSold = () => {
    return ['awaiting_notarial_deed', 'sold'].includes(state);
  };

  const zoomToSonar = () => {
    if (zoom <= 10) return '10';
    else if (zoom <= 12) return '20';
    else if (zoom <= 13) return '70';
    else if (zoom <= 14) return '130';
    else if (zoom <= 15) return '300';
    else if (zoom <= 16) return '500';
    else if (zoom <= 17) return '700';
    else if (zoom <= 18) return '900';
    else if (zoom <= 19) return '1100';
  };

  // ----------------------------- ACTION FUNCTIONS ----------------------------
  const handleClick = () => {
    if (property && property.id == id) dispatch(removeProperty());
    else dispatch(getProperty(id));
  };

  // -------------------------------- MAIN VIEW --------------------------------
  return (
    <>
      <div
        onClick={handleClick}
        style={{ '--sonar': zoomToSonar() + 'px' }}
        className={`vesta-tag-price ${isSold() ? 'vesta-tag-price--sold' : null} ${approximate_location ? 'vesta-tag-approx-location' : ''}${
          id === (property && id === property.id) ? 'hoverEffect' : ''
        }`}
      >
        <span className='typo-bold-content'>{formatPrice(Number(price))}</span>
      </div>
    </>
  );
};

OnGoogleApiLoadedMarker.propTypes = {
  id: propTypes.number.isRequired,
  zoom: propTypes.number.isRequired,
  price: propTypes.number.isRequired,
  state: propTypes.string.isRequired,
  approximate_location: propTypes.bool.isRequired
};

export default OnGoogleApiLoadedMarker;
